import React from 'react';

import { useLoyaltyOfferGroupsExperiment } from 'experiments/use-loyalty-offer-groups-experiment';
import { useLoyaltyOffersUiLoggedOutQuery } from 'generated/sanity-graphql';
import { maybeLocale } from 'utils/graphql';

import { Body, Container, StyledButton, Title } from './loyalty-end-of-offers-logged-out.styled';

const LoyaltyEndOfOffersLoggedOut = () => {
  const offerGroupExperimentEnabled = useLoyaltyOfferGroupsExperiment(true);
  const { data } = useLoyaltyOffersUiLoggedOutQuery({
    variables: {
      id: offerGroupExperimentEnabled
        ? 'feature-loyalty-offers-ui-singleton-experiment'
        : 'feature-loyalty-offers-ui-singleton',
    },
  });

  const endOfOffersLoggedOut = data?.LoyaltyOffersUI?.endOfOffersLoggedOut;
  const title = maybeLocale(endOfOffersLoggedOut?.title);
  const body = maybeLocale(endOfOffersLoggedOut?.body);
  const buttonText = maybeLocale(endOfOffersLoggedOut?.ctaButtonText);
  const buttonLink = maybeLocale(endOfOffersLoggedOut?.link);

  return title ? (
    <Container>
      <Title>{title}</Title>
      {body && <Body>{body}</Body>}
      {buttonText && buttonLink && <StyledButton to={buttonLink}>{buttonText}</StyledButton>}
    </Container>
  ) : null;
};

export default LoyaltyEndOfOffersLoggedOut;
